var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgInterrogation = function SvgInterrogation(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8E1538",
    d: "M54.201 40.398l-8.39 11.137a1.19 1.19 0 0 1-1.779.12l-4.327-4.304a1 1 0 0 0-1.41 1.418l4.333 4.31a3.195 3.195 0 0 0 2.474.912 3.17 3.17 0 0 0 2.31-1.257l8.387-11.132a1 1 0 0 0-1.598-1.204zM47 64c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.603 17 17 17zm0-2c-8.29 0-15-6.713-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B3A3A",
    fillRule: "nonzero",
    d: "M13 56a1 1 0 0 1 0-2h7.204l2.538-11H9.269C4.243 43 .146 39.029.004 34.071l-.001-.017L0 34V9.203C0 4.121 4.154 0 9.27 0h45.469C59.846 0 64 4.122 64 9.203V30a1 1 0 0 1-2 0V9.203C62 5.23 58.746 2 54.739 2H9.269C5.255 2 2 5.229 2 9.203V33h25a1 1 0 0 1 .993.883L28 34a1 1 0 0 1-1 1H2.1c.575 3.404 3.565 6 7.17 6h14.71a1.002 1.002 0 0 1 .994 1.225l-3 13a1 1 0 0 1-.97.775z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInterrogation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/interrogation.74f76ed5.svg";
export { ForwardRef as ReactComponent };